module.exports = __webpack_public_path__ + "img/elo.905c633.svg";